import { REPORT_TYPE_IDS } from "../../../store/constants";
import AnnualDataQuality from "./AnnualDataQuality";

const AnnualWaitDistribution = () => (
  <AnnualDataQuality
    reportTypeId={REPORT_TYPE_IDS.annual_wait_time_distribution_peak_wait}
    title="Annual Wait-Time Distribution and Peak-Wait"
    description="Annual wait distribution, peak-wait exceptions, percentile bands, and raw-sample confidence."
    emptyDataMessage="Annual Wait Distribution data is empty for the selected year."
    searchPrompt="Update filters and hit Search to retrieve annual Wait Distribution data."
  />
);

export default AnnualWaitDistribution;
